import { render, staticRenderFns } from "./GiftCardRatesCard.vue?vue&type=template&id=0c6ebf81&"
import script from "./GiftCardRatesCard.vue?vue&type=script&lang=ts&"
export * from "./GiftCardRatesCard.vue?vue&type=script&lang=ts&"
import style0 from "./GiftCardRatesCard.vue?vue&type=style&index=0&id=0c6ebf81&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports